import { takeLatest, call, put, all } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import { push as pushHistory } from 'react-router-redux'

import actions, { constants } from 'common/actions/user'
import snackbarActions from 'common/actions/snackbar'
import modalActions from 'common/actions/modal'

import * as schemas from 'schemas'
import * as api from 'api/user'
import * as Strings from 'constants/Strings'
import * as Routes from 'constants/Routes'

export function* onLoadUsers() {
  yield put(actions.loadUsersRequest.start())

  try {
    const { users } = yield call(api.loadUsers)
    const norm = yield call(normalize, users, [schemas.user])
    yield put(actions.loadUsersRequest.success(norm))
  } catch (err) {
    yield put(actions.loadUsersRequest.failure(err))
    yield put(snackbarActions.showSnackbar(Strings.WHOOPS))

    if (err?.status === 401 || err?.status === 403) {
      yield put(pushHistory(Routes.LOGIN))
    }
  }
}

export function* onUpdateUserPremium({ payload: data }) {
  const meta = { customerId: data.customerId }
  yield put(actions.updateUserPremiumRequest.start(undefined, meta))
  try {
    yield call(api.updateUserPremium, data.data, data.customerId)

    yield put(actions.updateUserPremiumRequest.success({ data }))
  } catch (err) {
    yield put(actions.updateUserPremiumRequest.failure(err, meta))
    yield put(snackbarActions.showSnackbar(Strings.WHOOPS))
  }
}

export function* onUpdateUserApiService({ payload: data }) {
  const meta = { customerId: data.customerId }
  yield put(actions.updateUserApiServiceRequest.start(undefined, meta))
  try {
    yield call(api.updateUserApiService, data.data, data.customerId)

    yield put(actions.updateUserApiServiceRequest.success({ data }))
  } catch (err) {
    yield put(actions.updateUserApiServiceRequest.failure(err, meta))
    yield put(snackbarActions.showSnackbar(Strings.WHOOPS))
  }
}

export function* onUpdateUserLimit({ payload: data }) {
  const meta = { customerId: data.customerId }
  yield put(actions.updateUserLimitRequest.start(undefined, meta))
  try {
    yield call(api.updateUserLimit, data.data, data.customerId)

    yield put(actions.updateUserLimitRequest.success({ data }))
    yield put(snackbarActions.showSnackbar(Strings.SUCCESSFUL_UPDATED_USER_LIMIT))
  } catch (err) {
    yield put(actions.updateUserLimitRequest.failure(err, meta))
    yield put(snackbarActions.showSnackbar(Strings.WHOOPS))
  }
}

export function* onUpdateUserApiServiceLimit({ payload: data }) {
  const meta = { customerId: data.customerId }
  yield put(actions.updateUserApiServiceLimitRequest.start(undefined, meta))
  try {
    yield call(api.updateUserApiServiceLimit, data.data, data.customerId)

    yield put(actions.updateUserApiServiceLimitRequest.success({ data }))
    yield put(snackbarActions.showSnackbar(Strings.SUCCESSFUL_UPDATED_USER_API_SERVICE_LIMIT))
  } catch (err) {
    yield put(actions.updateUserApiServiceLimitRequest.failure(err, meta))
    yield put(snackbarActions.showSnackbar(Strings.WHOOPS))
  }
}

const normalizeAddedSystems = system => {
  if (Array.isArray(system)) return system
  if (system) return [system]

  return []
}

export function* onAddSystemToUser({ payload: data }) {
  yield put(actions.addSystemToUserRequest.start())

  const { userId, ...requestData } = data || {}

  try {
    const { system, selectedProject } = yield call(api.addSystemToUser, userId, requestData)
    const norm = yield call(normalize, normalizeAddedSystems(system), [schemas.system])

    yield put(actions.addSystemToUserRequest.success({ ...norm, selectedProject }))
    yield put(snackbarActions.showSnackbar('Dispositivo añadido con éxito'))
    yield put(actions.loadUsers())
    yield put(modalActions.hideModal())
  } catch (err) {
    const errorData = err?.responseBody

    if (err?.status === 409 && errorData) {
      const { system, systemFailed, selectedProject } = errorData
      const addedSystems = normalizeAddedSystems(system)

      if (addedSystems.length > 0) {
        const norm = yield call(normalize, addedSystems, [schemas.system])
        yield put(actions.addSystemToUserRequest.success({ ...norm, selectedProject }))
        yield put(actions.loadUsers())
      }

      yield put(
        actions.addSystemToUserRequest.failure({
          error: err,
          systemFailed
        })
      )
      yield put(snackbarActions.showSnackbar('Algunos dispositivos no se han podido añadir'))
    } else {
      yield put(actions.addSystemToUserRequest.failure({ error: err }))
      yield put(
        snackbarActions.showSnackbar(
          err?.status === 411 ? 'Límite de dispositivos alcanzado' : Strings.WHOOPS
        )
      )
    }
  }
}

export default function* watchUser() {
  yield all([
    takeLatest(constants.LOAD_USERS, onLoadUsers),
    takeLatest(constants.UPDATE_USER_PREMIUM, onUpdateUserPremium),
    takeLatest(constants.UPDATE_USER_API_SERVICE, onUpdateUserApiService),
    takeLatest(constants.UPDATE_USER_LIMIT, onUpdateUserLimit),
    takeLatest(constants.UPDATE_USER_API_SERVICE_LIMIT, onUpdateUserApiServiceLimit),
    takeLatest(constants.ADD_SYSTEM_TO_USER, onAddSystemToUser)
  ])
}
